import 'antd/dist/reset.css';
import './main.css';
import { browserTracingIntegration, replayIntegration } from '@sentry/browser';
import { init } from '@sentry/react';
import { createRoot } from 'react-dom/client';

import App from './app/app';

init({
  dsn: `${import.meta.env.VITE_SENTRY_DSN}`,
  integrations: [browserTracingIntegration(), replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: import.meta.env.PROD,
});

createRoot(document.getElementById('root') as HTMLElement).render(<App />);
